import HomePage from "~/pages/HomePage";
import { homeSearchSchema } from "~/utils/dataset-deeplink";
import { queryClient, trpc } from "~/utils/trpc";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/")({
  component: HomePage,
  validateSearch: homeSearchSchema,
  beforeLoad: async ({ location }) => {
    const session = await queryClient.fetchQuery(trpc.auth.getSession.queryOptions()).catch(() => null);
    if (!session?.isLoggedIn) {
      throw redirect({ to: "/login", search: { redirectTo: location.href } });
    }
    if (session.authStage === "first_factor") {
      throw redirect({ to: "/select-dataset", search: { redirectTo: location.href } });
    }
    if (session.authStage === "mfa_pending") {
      throw redirect({ to: "/mfa", search: { redirectTo: location.href } });
    }
  },
});
